import { JSX } from "react";
import { View, Text } from "react-native";
import InfoAlert from "@/assets/icons/main/blueAlert.svg"

const TextBanner = (): JSX.Element => {
  return (
    <View className="py-3 px-4 blue-banner rounded-2xl flex-row gap-3 mt-5 mb-5">
      <InfoAlert style={{ width: 20, height: 20, flexShrink: 0 }} />
      <Text className="text-base">
        Уведомления можно подключить только к одной компании. Отменить или изменить подключение нельзя.
      </Text>
    </View>
  );
};

export default TextBanner;